/**
 * 注册自定义指令
 */
import * as directives from '@fanghub/tool-directives'
import { permission } from './permission'

export const setupDirectivesTools = app => {
    for (const [key, directive] of Object.entries(directives)) {
        if (key !== 'permission') {
            app.directive(key, directive)
        }
    }
    app.directive('permission', permission())
}
